import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Options } from '@angular-slider/ngx-slider';

@Component({
  selector: 'kve-margin-input',
  templateUrl: './margin-input.component.html',
  styleUrls: ['./margin-input.component.scss']
})
export class MarginInputComponent implements OnInit {
  sliderControl: FormControl = new FormControl(0);
  options: Options = {
    floor: 0,
    ceil: 12
  };
  valueAll = 8;
  valueTop = 8;
  valueRight = 8;
  valueBottom = 8;
  valueLeft = 8;
  constructor() { }

  ngOnInit(): void {
  }

}
